import { combineReducers } from 'redux'
import misc from './misc'

export default combineReducers({
  misc,
})
